import Vue from 'vue';
import Router from 'vue-router';
import PC from './PC'; // 引入基础路由
import store from '../store';
import commonPRAS from "../common/constant";


// 获取原型对象上的 push 函数
const originalPush = Router.prototype.push;
// 修改原型对象中的 push 方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

// 基础路由
const routesP = PC;
let base = '/admin';

const router = new Router({
  mode: 'history',
  routes: routesP,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

// 动态添加路由的函数
const addedRoutes = []; // 记录已添加的动态路由

export function addDynamicRoutes(menus) {
  const generateRoutes = (menuList = '') => {
    return menuList.map(menu => {
      const route = {
        path: `${menu.path}`,
        name: menu.name,
        icon: menu.icon || '',
        redirect: menu.redirect,
        meta: {
          title: menu.title || '',
          keepAlive: menu.keepAlive || false,
          needLogin: menu.needLogin || false,
        },
        component: menu.childrenMenus && menu.childrenMenus.length
          ? { render: h => h('router-view') }
          : () => import(`@/views${menu.componentName}.vue`)
      };

      if (menu.childrenMenus && menu.childrenMenus.length) {
        route.children = generateRoutes(menu.childrenMenus);
      }

      return route;
    });
  };

  const routes = generateRoutes(menus, '');
  routes.forEach(route => {
    if (!addedRoutes.some(r => r.name === route.name)) { // 检查是否已经添加过
      router.addRoute(route);
      addedRoutes.push(route); // 记录添加的路由
    }
  });

  // console.log("动态路由添加结束", router.getRoutes());
}
let hasRoutes = true
// 全局路由守卫
router.beforeEach((to, from, next) => {
  const accessToken = localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken");

  // 如果用户已登录，检查是否需要添加动态路由
  if (accessToken) {
    // 已登录：触发常驻站点拉取（会话内幂等），覆盖首次登录后与每次刷新场景
    store.dispatch("fetchDefaultBelong");
    // 只在首次访问时添加动态路由
    if (hasRoutes) {
      initializeRoutes().then(r =>{
        hasRoutes = false
        next({ ...to, replace: true }); // 重定向到同一路径以重新解析
      } );
    } else {
      next(); // 继续导航
    }
    // 获取权限菜单并设置当前菜单权限
    const menus = store.getters['permission/getMenus'];
    if (menus && menus.length) {
      store.dispatch('permission/setMenu', to.fullPath);
    }
  } else {
    // 如果未登录，处理需要登录的页面
    if (to.meta.needLogin) {
      next({ path: '/login', replace: true });
    } else {
      next(); // 继续未登录的页面
    }
  }
});

// 在用户登录后调用此函数来添加动态路由
export async function initializeRoutes() {
  const menus = await store.getters['permission/getMenus']; // 从 Vuex 获取 menus
  if (menus && menus.length) {
    addDynamicRoutes(menus);
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js